<div class="snackbar">
  <mat-icon (click)="closeSnackBar()" *ngIf="data.icon"> {{ data.icon }}</mat-icon>
  <span> {{ data.message }} </span>
</div>
